<div class="read-more-container">
    <div class="read-more-content">
        <!--    -->
        <div class="current-text"
             [innerHTML]="currentText">
        </div>

        <!--    -->
        <a *ngIf="!hideToggle"
           class="show-more-button"
           (click)="toggleView()"
           fxLayout="row"
           fxLayoutAlign="start center">
            <span>{{toggleText|translate}}</span>
            <mat-icon color="primary"
                      [@indicatorRotate]="isCollapsed ? 'collapsed':'expanded'">
                keyboard_arrow_down
            </mat-icon>
        </a>
    </div>
</div>
